/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetYoutubeIntegrationCuepointsCuepointsQueryResponse, WebAppGetYoutubeIntegrationCuepointsCuepointsQueryParams, WebAppGetYoutubeIntegrationCuepointsCuepoints401, WebAppGetYoutubeIntegrationCuepointsCuepoints403 } from "../models/WebAppGetYoutubeIntegrationCuepointsCuepoints";

export function getWebAppGetYoutubeIntegrationCuepointsCuepointsUrl() {
  const res = { method: 'GET', url: `/web-app/v1/youtube-cuepoints` as const }
  return res
}

/**
 * @description Read-only audit log of successful cuepoints, scoped to the caller client.
 * @summary List cuepoints for the authenticated client (paginated, filter, sort)
 * {@link /web-app/v1/youtube-cuepoints}
 */
export async function webAppGetYoutubeIntegrationCuepointsCuepoints(params?: WebAppGetYoutubeIntegrationCuepointsCuepointsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppGetYoutubeIntegrationCuepointsCuepointsQueryResponse, ResponseErrorConfig<WebAppGetYoutubeIntegrationCuepointsCuepoints401 | WebAppGetYoutubeIntegrationCuepointsCuepoints403>, unknown>({ method : "GET", url : getWebAppGetYoutubeIntegrationCuepointsCuepointsUrl().url.toString(), params, ... requestConfig })
  return res.data
}